import { render, staticRenderFns } from "./GanttChartView.vue?vue&type=template&id=564b81c6&"
import script from "./GanttChartView.vue?vue&type=script&lang=js&"
export * from "./GanttChartView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports